import Button from '@/components/Button';
import Container from '@/components/Container';
import {
  Render,
  Article,
  ChartContainer,
  Summary,
  TableContainer,
  NoticeBox,
} from '@/components/Css/ReportKorea';
import DonutChartComponent from '@/components/DonutChart';
import LinkSafe from '@/components/LinkSafe';
import PageComponent from '@/components/PageComponent';
import SectionHeader from '@/components/SectionHeader';
import { Tit } from '@/components/Titles';
import YoutubeSingle from '@/components/YoutubeSingle';
import React from 'react';
import { breakpoint } from '@/helpers/BreakpointHelper';
import styled from 'styled-components';

const SectionYoutube = styled.div`
  margin-bottom: 160px;
  ${breakpoint(`tablet`)} {
    margin-bottom: 160px;
  }

  ${breakpoint(`mobile`)} {
    margin-bottom: 60px;
  }
`;

const incomeData = [
  {
    type: `후원금 수입`,
    data: [
      {
        name: `정기 후원`,
        amount: 137194205607,
        rate: 80.0,
        tip: `매월 정해진 금액을 후원하는 것`,
      },
      {
        name: `일시 후원`,
        amount: 5990361883,
        rate: 3.5,
        tip: `개인이나 단체가 비정기적으로 후원하는 것`,
      },
      {
        name: `기업 후원`,
        amount: 7061750111,
        rate: 4.1,
      },
      {
        name: `비영리기관 후원`,
        amount: 1590891197,
        rate: 0.9,
      },
    ],
  },
  {
    type: `후원금 외 수입`,
    data: [
      {
        name: `본부 지원금`,
        amount: 15846601856,
        rate: 9.2,
      },
      {
        name: `이자수익 및 기타`,
        amount: 1829433709,
        rate: 1.1,
        tip: `예금이자수익 등`,
      },
      {
        name: `수익사업`,
        amount: 397446792,
        rate: 0.3,
      },
      {
        name: `고유목적사업준비금환입액`,
        amount: 1525936907,
        rate: 0.9,
      },
    ],
  },
];
const incomeTotalArry = [0, 0];
incomeData.map((row, index) => {
  row.data.map((row2) => {
    incomeTotalArry[index] += row2.amount;
  });
});
const incomeTotal = incomeTotalArry[0] + incomeTotalArry[1];

const incomePerArry = [0, 0];
incomeData.map((row, index) => {
  row.data.map((row2) => {
    //incomePerArry[index] += (row2.amount / incomeTotal) * 100;
    // 250502 금액으로 합산 할 경우 수치 오류로 비율 합산으로 변경
    incomePerArry[index] += row2.rate;
  });
});

const spendingData = [
  {
    type: `고유목적사업`,
    data: [
      {
        name: `개발도상국 지원비`,
        amount: 123480166097,
        rate: 72.0,
        tip: `157개 나라의 유니세프 프로그램 지원비`,
      },
      {
        name: `아동권리 옹호 및 PR 등`,
        amount: 20442250546,
        rate: 11.9,
        tip: `후원자 관리 및 제반 홍보활동, 국내아동권리 옹호 및 교육 프로그램`,
      },
      {
        name: `인건비 및 관리 운영비`,
        amount: 8549914680,
        rate: 5.0,
        tip: `인건비 및 법인 운영관련 비용 등`,
      },
      {
        name: `본부 지원금`,
        amount: 15743004237,
        rate: 9.2,
      },
      {
        name: `기타`,
        amount: 113466750,
        rate: 0.1,
      },
    ],
  },
  {
    type: `기타사업`,
    data: [
      {
        name: `수익사업비용`,
        amount: 329471474,
        rate: 0.2,
      },
    ],
  },
  {
    type: `고유목적사업준비금전입액`,
    rowspan: true,
    data: [
      {
        name: `고유목적사업준비금전입액`,
        amount: 1489900537,
        rate: 0.9,
      },
    ],
  },
  {
    type: `법인세비용`,
    rowspan: true,
    data: [
      {
        name: `법인세비용`,
        amount: 4762773,
        rate: 0.0,
      },
    ],
  },
  {
    type: `당기운영이익`,
    rowspan: true,
    data: [
      {
        name: `당기운영이익`,
        amount: 1283690968,
        rate: 0.7,
      },
    ],
  },
];
const spendingTotalArry = [0, 0, 0, 0, 0];
spendingData.map((row, index) => {
  row.data.map((row2) => {
    spendingTotalArry[index] += row2.amount;
  });
});

const spendingTotal =
  spendingTotalArry[0] +
  spendingTotalArry[1] +
  spendingTotalArry[2] +
  spendingTotalArry[3] +
  spendingTotalArry[4];

const numberFormat = (num: number) =>
  num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `,`);

const ReportKorea2024: React.FC = (props) => (
  <Render>
    <Container>
      <ul
        className="btn-flex flex"
        css={`
          ${breakpoint(`mobile`)} {
            margin-bottom: 60px !important;
          }
        `}
      >
        <li>
          <LinkSafe
            to={`${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9jbGVhcg==&dispFileNm=2024_audit_report.pdf&svrFileNm=2024_audit_report.pdf`}
          >
            <Button outline full ico="down" className="btn-report">
              <span className="ico">감사보고서</span>
            </Button>
          </LinkSafe>
        </li>
        <li>
          <LinkSafe
            to={`${process.env.BACKEND_URL}/unicef/api/common/attachFile/download?attUploadPath=L01JRy9jbGVhcg==&dispFileNm=2024_performance_report.pdf&svrFileNm=2024_performance_report.pdf`}
          >
            <Button outline full ico="down" className="btn-report">
              <span className="ico">
                기부금 모금액 및 <br />
                활용 실적
              </span>
            </Button>
          </LinkSafe>
        </li>
        <li>
          <LinkSafe
            to="https://teht.hometax.go.kr/websquare/websquare.html?w2xPath=/ui/sf/a/c/UTESFACI01.xml"
            target="_blank"
          >
            <Button outline full ico="share" className="btn-report">
              <span className="ico">국세청 공시 시스템</span>
            </Button>
          </LinkSafe>
        </li>
      </ul>
    </Container>

    <SectionYoutube>
      <PageComponent id="youtube1">
        <YoutubeSingle videoId="Ya4hew60hdc" />
      </PageComponent>
    </SectionYoutube>

    <Container>
      <SectionHeader className="with-desc">
        <h2>
          <Tit size="s1">
            유니세프한국위원회는
            <br />
            후원금을 투명하게 운영합니다
          </Tit>
        </h2>
      </SectionHeader>

      <Article>
        <h3>
          <Tit size="s2">정기감사</Tit>
        </h3>
        <p className="dec">
          유니세프한국위원회는 내부 감사, 유니세프 본부 및 외부회계법인 감사를
          통해 후원금 사용의 투명성을 검증받습니다.
        </p>
        <NoticeBox>
          <ul className="blit-list">
            <li>
              <strong>유니세프한국위원회 내부 감사</strong> 연 1회 이사회 감사
            </li>
            <li>
              <strong>유니세프 본부 감사</strong> 연 1회 감사
            </li>
            <li>
              <strong>외부 감사</strong> 연 1회 (2024년 삼덕회계법인 감사)
            </li>
          </ul>
        </NoticeBox>
      </Article>

      <Article>
        <h3>
          <Tit size="s2">국세청 공시</Tit>
        </h3>
        <p className="dec">
          공익법인 결산서류 공시 의무에 따라 매년 국세청에 결산 서류, 연간 기부금
          모금액 및 활용실적 등을 제출하여 국세청 웹사이트에 공시합니다.
        </p>
      </Article>

      <SectionHeader className="with-desc">
        <h2>
          <Tit size="s1">유니세프한국위원회 결산</Tit>
        </h2>
      </SectionHeader>

      <Article>
        <h3 className="sky-bd">
          <Tit size="s2" color="sky">
            2024 수입
          </Tit>
        </h3>
        <ChartContainer>
          <div className="m-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 20px;'>수입</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                incomeTotal,
              )}</b><b style='font-size:20px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: incomeData[0].data[0].name,
                      y: incomeData[0].data[0].rate,
                    },
                    {
                      name: incomeData[0].data[1].name,
                      y: incomeData[0].data[1].rate,
                    },
                    {
                      name: incomeData[0].data[2].name,
                      y: incomeData[0].data[2].rate,
                    },
                    {
                      name: incomeData[0].data[3].name,
                      y: incomeData[0].data[3].rate,
                    },
                    {
                      name: incomeData[1].data[0].name,
                      y: incomeData[1].data[0].rate,
                    },
                    {
                      name: incomeData[1].data[1].name,
                      y: incomeData[1].data[1].rate,
                    },
                    {
                      name: incomeData[1].data[2].name,
                      y: incomeData[1].data[2].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
          <div className="pc-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 14px;'>수입</span><br><b style='font-size: 20px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                incomeTotal,
              )}</b><b style='font-size:14px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: incomeData[0].data[0].name,
                      y: incomeData[0].data[0].rate,
                    },
                    {
                      name: incomeData[0].data[1].name,
                      y: incomeData[0].data[1].rate,
                    },
                    {
                      name: incomeData[0].data[2].name,
                      y: incomeData[0].data[2].rate,
                    },
                    {
                      name: incomeData[0].data[3].name,
                      y: incomeData[0].data[3].rate,
                    },
                    {
                      name: incomeData[1].data[0].name,
                      y: incomeData[1].data[0].rate,
                    },
                    {
                      name: incomeData[1].data[1].name,
                      y: incomeData[1].data[1].rate,
                    },
                    {
                      name: incomeData[1].data[2].name,
                      y: incomeData[1].data[2].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
        </ChartContainer>
        <TableContainer>
          <table className="tbl1">
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col3" />
            </colgroup>
            <thead>
              <tr>
                <th>구분</th>
                <th>금액(원)</th>
                <th>비율</th>
              </tr>
            </thead>
            {incomeData.map((row, index) => (
              <tbody key={index}>
                <tr>
                  <th colSpan="3">
                    <strong>{row.type}</strong>
                  </th>
                </tr>
                {row.data.map((row2) => (
                  <tr>
                    <td>
                      {row2.name} {row2.tip && `*`}
                    </td>
                    <td>
                      <p className="price">{numberFormat(row2.amount)}</p>
                    </td>
                    <td>
                      <p className="price">{row2.rate.toFixed(1)}%</p>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td>
                    <strong>소계</strong>
                  </td>
                  <td>
                    <p className="price">
                      {numberFormat(incomeTotalArry[index])}
                    </p>
                  </td>
                  <td>
                    <p className="price">{incomePerArry[index].toFixed(1)}%</p>
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
        </TableContainer>
        <NoticeBox>
          <ul className="blit-list">
            {incomeData.map((row, index) => (
              <>
                {row.data.map((row2, index2) => (
                  <>
                    {row2.tip && (
                      <li>
                        <strong>{row2.name} : </strong>
                        {row2.tip}
                      </li>
                    )}
                  </>
                ))}
              </>
            ))}
          </ul>
        </NoticeBox>
      </Article>

      <Article>
        <h3 className="sky-bd">
          <Tit size="s2" color="sky">
            2024 지출
          </Tit>
        </h3>
        <ChartContainer>
          <div className="m-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 20px;'>지출</span><br><b style='font-size: 36px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                spendingTotal,
              )}</b><b style='font-size:20px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: spendingData[0].data[0].name,
                      y: spendingData[0].data[0].rate,
                    },
                    {
                      name: spendingData[0].data[1].name,
                      y: spendingData[0].data[1].rate,
                    },
                    {
                      name: spendingData[0].data[2].name,
                      y: spendingData[0].data[2].rate,
                    },
                    {
                      name: spendingData[0].data[3].name,
                      y: spendingData[0].data[3].rate,
                    },
                    {
                      name: spendingData[0].data[4].name,
                      y: spendingData[0].data[4].rate,
                    },
                    {
                      name: spendingData[1].data[0].name,
                      y: spendingData[1].data[0].rate,
                    },
                    {
                      name: spendingData[2].data[0].name,
                      y: spendingData[2].data[0].rate,
                    },
                    {
                      name: spendingData[3].data[0].name,
                      y: spendingData[3].data[0].rate,
                    },
                    {
                      name: spendingData[4].data[0].name,
                      y: spendingData[4].data[0].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
          <div className="pc-hide">
            <DonutChartComponent
              centerText={`<span style='font-size: 14px;'>지출</span><br><b style='font-size: 20px;letter-spacing: -1.6px;color:#3162af'>${numberFormat(
                spendingTotal,
              )}</b><b style='font-size:14px;color:#3162af'>원</b>`}
              series={[
                {
                  name: ``,
                  colorByPoint: true,
                  innerSize: `65%`,
                  type: `pie`,
                  data: [
                    {
                      name: spendingData[0].data[0].name,
                      y: spendingData[0].data[0].rate,
                    },
                    {
                      name: spendingData[0].data[1].name,
                      y: spendingData[0].data[1].rate,
                    },
                    {
                      name: spendingData[0].data[2].name,
                      y: spendingData[0].data[2].rate,
                    },
                    {
                      name: spendingData[0].data[3].name,
                      y: spendingData[0].data[3].rate,
                    },
                    {
                      name: spendingData[0].data[4].name,
                      y: spendingData[0].data[4].rate,
                    },
                    {
                      name: spendingData[1].data[0].name,
                      y: spendingData[1].data[0].rate,
                    },
                    {
                      name: spendingData[2].data[0].name,
                      y: spendingData[2].data[0].rate,
                    },
                    {
                      name: spendingData[3].data[0].name,
                      y: spendingData[3].data[0].rate,
                    },
                    {
                      name: spendingData[4].data[0].name,
                      y: spendingData[4].data[0].rate,
                    },
                  ],
                },
              ]}
            />
          </div>
        </ChartContainer>

        <TableContainer>
          <table className="tbl1">
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col3" />
            </colgroup>
            <thead>
              <tr>
                <th>구분</th>
                <th>금액(원)</th>
                <th>비율</th>
              </tr>
            </thead>
            {spendingData.map((row, index) => (
              <tbody key={index}>
                {!row.rowspan ? (
                  <tr>
                    <th colSpan="3">
                      <strong>{row.type}</strong>
                    </th>
                  </tr>
                ) : (
                  <tr>
                    <th>
                      <strong>{row.type}</strong>
                    </th>
                    <th>
                      <p className="price">{numberFormat(row.data[0].amount)}</p>
                    </th>
                    <th>
                      <p className="price">{row.data[0].rate.toFixed(1)}%</p>
                    </th>
                  </tr>
                )}
                {!row.rowspan &&
                  row.data.map((row2) => (
                    <tr>
                      <td>
                        {row2.name} {row2.tip && `*`}
                      </td>
                      <td>
                        <p className="price">{numberFormat(row2.amount)}</p>
                      </td>
                      <td>
                        <p className="price">{row2.rate.toFixed(1)}%</p>
                      </td>
                    </tr>
                  ))}
              </tbody>
            ))}
          </table>
        </TableContainer>
        <NoticeBox>
          <ul className="blit-list">
            {spendingData.map((row, index) => (
              <>
                {row.data &&
                  row.data.map((row2, index2) => (
                    <>
                      {row2.tip && (
                        <li>
                          <strong>{row2.name} : </strong>
                          {row2.tip}
                        </li>
                      )}
                    </>
                  ))}
              </>
            ))}
          </ul>
        </NoticeBox>
      </Article>

      <Article>
        <h3 className="sky-bd">
          <Tit size="s2" color="sky">
            {props.selectYear} 2024 개발도상국 지원비
          </Tit>
        </h3>
        <TableContainer>
          <Summary>개발도상국 어린이 지원 총계 : 123,480,166,097원</Summary>
          <table className="tbl3">
            <colgroup>
              <col className="col1" />
              <col className="col2" />
              <col className="col4" />
            </colgroup>
            <thead>
              <tr>
                <th>구분</th>
                <th>금액(원)</th>
                <th>비율</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>
                  <strong>일반사업비</strong>
                </th>
                <th>
                  <p className="price">109,847,499,026</p>
                </th>
                <th>
                  <p className="price">89.0%</p>
                </th>
              </tr>
              <tr>
                <th>
                  <strong>지정사업비</strong>
                </th>
                <th>
                  <p className="price">13,632,667,071</p>
                </th>
                <th>
                  <p className="price">11.0%</p>
                </th>
              </tr>

              <tr>
                <th colSpan="3">
                  <strong style={{ marginLeft: '15px', color: '#000' }}>
                    글로벌 캠페인
                  </strong>
                </th>
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    에이즈 예방
                  </p>
                </td>
                <td>
                  <p className="price">5,656,451,199</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    기후 변화
                  </p>
                </td>
                <td>
                  <p className="price">1,371,925,133</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    세계 어린이 보호
                  </p>
                </td>
                <td>
                  <p className="price">799,864,669</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    아시아 어린이 교육
                  </p>
                </td>
                <td>
                  <p className="price">410,500,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    생존과 발달
                  </p>
                </td>
                <td>
                  <p className="price">195,259,271</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '15px' }}>
                    식수 위생
                  </p>
                </td>
                <td>
                  <p className="price">30,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <th colSpan="3">
                  <strong style={{ marginLeft: '15px', color: '#000' }}>
                    국가별 지정사업
                  </strong>
                </th>
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    베트남 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">615,670,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    몽골 (기후 변화)
                  </p>
                </td>
                <td>
                  <p className="price">360,647,367</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    이라크 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">223,796,215</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    필리핀 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">215,670,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    몽골 (교육)
                  </p>
                </td>
                <td>
                  <p className="price">213,036,380</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    미얀마 (기후 변화)
                  </p>
                </td>
                <td>
                  <p className="price">149,174,877</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    마다가스카르 (기후 변화)
                  </p>
                </td>
                <td>
                  <p className="price">146,024,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    동아프리카 (어린이 지원 사업)
                  </p>
                </td>
                <td>
                  <p className="price">139,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    라오스 (식수)
                  </p>
                </td>
                <td>
                  <p className="price">50,000,000</p>
                </td>
                <td />
              </tr>

              <tr>
                <th colSpan="3">
                  <strong style={{ marginLeft: '15px', color: '#000' }}>
                    긴급구호
                  </strong>
                </th>
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    북한
                  </p>
                </td>
                <td>
                  <p className="price">1,342,918,287</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    가자지구
                  </p>
                </td>
                <td>
                  <p className="price">1,164,239,842</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    베트남
                  </p>
                </td>
                <td>
                  <p className="price">426,799,991</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    수단
                  </p>
                </td>
                <td>
                  <p className="price">57,189,840</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    모로코
                  </p>
                </td>
                <td>
                  <p className="price">20,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    시리아
                  </p>
                </td>
                <td>
                  <p className="price">20,000,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    레바논
                  </p>
                </td>
                <td>
                  <p className="price">14,500,000</p>
                </td>
                <td />
              </tr>
              <tr>
                <td>
                  <p className="country" style={{ marginLeft: '30px' }}>
                    우크라이나
                  </p>
                </td>
                <td>
                  <p className="price">10,000,000</p>
                </td>
                <td />
              </tr>
            </tbody>
          </table>
        </TableContainer>
        <NoticeBox>
          <ul className="blit-list">
            <li>
              <strong>일반사업비 : </strong>전 세계 157개 개발도상국의 유니세프
              사업비(보건, 에이즈, 식수와 위생, 영양, 교육, 어린이 보호, 사회통합
              등)
            </li>
            <li>
              <strong>지정사업비 : </strong>한국위원회가 직접 지원대상국과 사업을
              지정해서 보내는 사업비
            </li>
          </ul>
        </NoticeBox>
        <p
          className="tip"
          css={`
            margin-top: 32px;
          `}
        >
          ※ 사단법인 유니세프한국위원회는 정기적인 외부회계법인의 회계감사를 통해,
          법인의 공익성과 기부금 운영 투명성을 추구하고 있습니다. <br />
          {` `}
          2024
          {` `}
          회계연도 재무제표 등 경영성과 또한 삼덕회계법인의 실사 결과 적정하게
          표시되어 있음을 인정 받았습니다.
        </p>
      </Article>
    </Container>
  </Render>
);
export default ReportKorea2024;
